export default "__VITE_PUBLIC_ASSET__334c00dc__"